import styled from "styled-components";
import {Link} from "react-router-dom";

export const HeaderWrapper = styled.header`
  background-color: #FFFFFF;
  position: sticky;
  top: 0;
  z-index: 1001;
`;

export const HeaderLinksContainer = styled.div`
  
  @media (max-width: 992px) {
    transition: .4s;
    overflow: hidden;
    position: absolute;
    right: 0;
    top: 48px;
    width: 100%;
    background-color: #FDFDFE;
    padding: 2rem 1.5rem 1rem;
    
    &:not(.close) {
      opacity: 1;
      transform: translateY(0);
    }
    
    &.close {
      opacity: 0;
      transform: translateY(-120%);
    }
  }
`;

export const HeaderLinks = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;

  @media (max-width: 992px) {
    flex-direction: column;
    background-color: #FFFFFF;
    border-radius: 15px;
    border: 1px solid rgba(118, 133, 155, 0.3);
    padding-top: 2.5rem;
  }
`;


export const HeaderLink = styled.li`
  margin-right: 4rem;
  
  a {
    transition: .3s;
  }
  
  a.active {
    color: var(--success-color);
  }
  
  a:not(.active):hover {
    color: var(--dark-gray-color);
  }

  @media (max-width: 992px) {
    margin-right: 1.5rem;
    margin-bottom: 2.5rem;

    a.active {
      color: var(--success-color);
    }
  }
`;

export const LogoContainer = styled.img`
  width: 5.5rem;
`;

export const ProfileDropDownWrapper = styled.div`
  position: absolute;
  padding: 2.5rem 1.5rem;
  background-color: #FDFDFE;
        //#FDFDFE
  border-radius: 12px;
  border: 1px solid #EFF2F6;
  width: 500px;
  left: 0;
  top: 4rem;
  z-index: 1002;
`;

export const ProfileDropDownOverlay = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  background-color: transparent;
`;

export const HeaderLeftButton = styled.button`
  i {
    font-size: 1.2rem;  
  }
  
  i::before {
    color: #FFFFFF;
  }

  @media (max-width: 992px) {
    border-radius: 7px;

    i {
      display: none;
    }
  }
`;
